function Prices() {
   return (
      <div className="page">
         <h1>Preise wip</h1>
      </div>
   )
}

export default Prices;